module.exports = __webpack_public_path__ + "img/99_2.68f8b967.png";